;
define("sc_cct_html.tpl", function(){});

